var _rect, _text, _text2, _rect2, _rect3, _rect4, _text3, _circle, _text4, _text5, _text6, _text7, _rect5, _rect6, _rect7, _text8, _circle2, _text9, _text10, _text11, _text12, _rect8, _rect9, _rect10, _text13, _circle3, _text14, _text15, _text16, _text17, _text18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg08LoopSafeguards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 400",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 400,
    fill: "#f8fafc"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 38,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 20,
    fontWeight: 700
  }, "Loop Safeguards (Emergency Brakes)")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 62,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13
  }, "Without these, agents burn tokens and never converge")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 90,
    width: 280,
    height: 230,
    rx: 16,
    fill: "#ffffff",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 90,
    width: 280,
    height: 56,
    rx: 16,
    fill: "#fecaca",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 130,
    width: 280,
    height: 16,
    fill: "#fecaca"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 125,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 15,
    fontWeight: 700
  }, "Max Iterations")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 195,
    r: 28,
    fill: "#fee2e2",
    stroke: "#0f172a",
    strokeWidth: 2
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 201,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 16,
    fontWeight: 700
  }, "N")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 250,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13
  }, "Stop after N attempts")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 272,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12
  }, "Example: 5 steps")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 300,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Prevents infinite retries")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 90,
    width: 280,
    height: 230,
    rx: 16,
    fill: "#ffffff",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 90,
    width: 280,
    height: 56,
    rx: 16,
    fill: "#bfdbfe",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 130,
    width: 280,
    height: 16,
    fill: "#bfdbfe"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 125,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 15,
    fontWeight: 700
  }, "Time Budget")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 195,
    r: 28,
    fill: "#dbeafe",
    stroke: "#0f172a",
    strokeWidth: 2
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 201,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fontWeight: 700
  }, "60s")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 250,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13
  }, "Wall-clock deadline")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 272,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12
  }, "Example: 60 seconds")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 300,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Caps cost and latency")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 90,
    width: 280,
    height: 230,
    rx: 16,
    fill: "#ffffff",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 90,
    width: 280,
    height: 56,
    rx: 16,
    fill: "#bbf7d0",
    stroke: "#0f172a",
    strokeWidth: 2.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 130,
    width: 280,
    height: 16,
    fill: "#bbf7d0"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 125,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 15,
    fontWeight: 700
  }, "Duplicate Detection")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 195,
    r: 28,
    fill: "#dcfce7",
    stroke: "#0f172a",
    strokeWidth: 2
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 201,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "x2")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 250,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13
  }, "Same action + same args")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 272,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12
  }, "Seen twice = halt")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 300,
    textAnchor: "middle",
    fill: "#0f172a",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Stops thrashing")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 360,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12
  }, "On stop: dump goal, tool history, errors, and the exact stop reason.")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg08LoopSafeguards);
export default __webpack_public_path__ + "static/media/08-loop-safeguards.2f92dfe50086820720762d77b9c03e8c.svg";
export { ForwardRef as ReactComponent };